export enum PortalAppAction {
  DistrictSettingsUpdate = 'DistrictSettingsUpdate',
  UserPreferencesUpdate = 'UserPreferencesUpdate'
}